// extracted by mini-css-extract-plugin
module.exports = {"strong":"strong___3w3LA","serif":"serif___3Waxr"};